{
  "clear": "Helder",
  "invalid": "(ongeldig)",
  "loading": "Laden...",
  "noResults": "Geen resultaten"
}
